/**
 * Shared MUI Select MenuProps — fixed menu width, row layout, scroll only when needed.
 * Only Paper scrolls (not MenuList) to avoid stacked double scrollbars.
 */

export const dialogSelectMenuProps = {
  disableScrollLock: true,
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  sx: { zIndex: 1500 },
  MenuListProps: {
    dense: true,
    sx: { py: 0.25, maxHeight: "unset", overflow: "visible" },
  },
  PaperProps: {
    className: "scrollbar-widget",
    sx: {
      width: "min(92vw, 280px) !important",
      maxWidth: "min(92vw, 280px) !important",
      minWidth: "unset !important",
      mt: 0.5,
      borderRadius: "10px",
      "& .MuiMenuItem-root": {
        display: "flex !important",
        flexDirection: "row !important",
        alignItems: "center !important",
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    },
  },
};

/** Select menus inside Dialog — supports long option lists (e.g. bidder pickers). */
export const buildDialogSelectMenuProps = (
  optionCount = 0,
  { width = 280, scrollThreshold = 10, maxHeight = 320 } = {}
) => {
  const needsScroll = optionCount > scrollThreshold;
  return {
    disableScrollLock: true,
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
    sx: { zIndex: 1500 },
    MenuListProps: {
      dense: true,
      sx: { py: 0.25, maxHeight: "unset", overflow: "visible" },
    },
    PaperProps: {
      className: "scrollbar-widget",
      sx: {
        width: `min(92vw, ${width}px) !important`,
        maxWidth: `min(92vw, ${width}px) !important`,
        minWidth: "unset !important",
        mt: 0.5,
        borderRadius: "10px",
        ...(needsScroll
          ? { maxHeight, overflowY: "auto" }
          : { maxHeight: "none", overflow: "visible" }),
        "& .MuiMenuItem-root": {
          display: "flex !important",
          flexDirection: "row !important",
          alignItems: "center !important",
          whiteSpace: "normal",
          wordBreak: "break-word",
          py: 0.35,
          px: 1,
          minHeight: 32,
        },
      },
    },
  };
};

export const buildSelectMenuProps = (
  optionCount = 0,
  { width = 200, scrollThreshold = 12, maxHeight = 320 } = {}
) => {
  const needsScroll = optionCount > scrollThreshold;
  return {
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
    MenuListProps: {
      dense: true,
      sx: { py: 0.25, maxHeight: "unset", overflow: "visible" },
    },
    PaperProps: {
      className: "scrollbar-widget",
      sx: {
        width: `${width}px !important`,
        maxWidth: `${width}px !important`,
        minWidth: "unset !important",
        mt: 0.5,
        borderRadius: "10px",
        ...(needsScroll
          ? { maxHeight, overflowY: "auto" }
          : { maxHeight: "none", overflow: "visible" }),
        "& .MuiMenuItem-root": {
          display: "flex !important",
          flexDirection: "row !important",
          alignItems: "center !important",
          gap: 0.5,
          py: 0.35,
          px: 1,
          minHeight: 32,
          whiteSpace: "nowrap",
        },
      },
    },
  };
};
